import { UseFormReturnType } from '@mantine/form';
import { t } from 'i18next';
import { MedicalEventDataForm, MedicalEventTreatmentMethod, MedicalEventType } from 'models/patientMedicalEvent';
import { PatientData } from 'models/user';

interface Props {
  form: UseFormReturnType<MedicalEventDataForm, (values: MedicalEventDataForm) => MedicalEventDataForm>;
  patientData: PatientData;
}

const typeStringToMedicalEventType = (value?: string) => {
  switch (value) {
    case 'treatment':
      return MedicalEventType.Treatment;
    case 'diagnostic-result':
      return MedicalEventType.DiagnosticResult;
    default:
      return undefined;
  }
};

export const validateAddLogSubmission = ({ form, patientData }: Props) => {
  const {
    type,
    groupId,
    loggedTimestamp,
    treatment,
    procedure,
    iteration,
    technology,
    vendor,
    blankingPeriodInWeeks,
    medicationProtocol,
    medicationType,
    diagnosticMethod,
    diagnosticResult,
    comment,
  } = form.getValues();
  const submitData = {
    patientId: patientData?.id,
    groupId,
    type: typeStringToMedicalEventType(type),
    loggedTimestamp,
    treatment: type === MedicalEventType.Treatment ? treatment : undefined,
    procedure:
      type === MedicalEventType.Treatment &&
      (treatment === MedicalEventTreatmentMethod.CatheterAblation ||
        treatment === MedicalEventTreatmentMethod.Cardioversion)
        ? procedure
        : undefined,
    iteration:
      type === MedicalEventType.Treatment && treatment === MedicalEventTreatmentMethod.CatheterAblation
        ? iteration
        : undefined,
    technology:
      type === MedicalEventType.Treatment && treatment === MedicalEventTreatmentMethod.CatheterAblation
        ? technology
        : undefined,
    vendor:
      type === MedicalEventType.Treatment && treatment === MedicalEventTreatmentMethod.CatheterAblation
        ? vendor
        : undefined,
    blankingPeriodInWeeks:
      type === MedicalEventType.Treatment && treatment === MedicalEventTreatmentMethod.CatheterAblation
        ? blankingPeriodInWeeks
        : undefined,
    medicationProtocol:
      type === MedicalEventType.Treatment && treatment === MedicalEventTreatmentMethod.Medication
        ? medicationProtocol
        : undefined,
    medicationType:
      type === MedicalEventType.Treatment && treatment === MedicalEventTreatmentMethod.Medication
        ? medicationType
        : undefined,
    diagnosticReason: type === MedicalEventType.DiagnosticResult ? 'arrhythmias' : undefined,
    diagnosticMethod: type === MedicalEventType.DiagnosticResult ? diagnosticMethod : undefined,
    diagnosticResult: type === MedicalEventType.DiagnosticResult ? diagnosticResult : undefined,
    comment: comment || undefined,
  };

  return submitData;
};

export const getLogColor = (value?: string) => {
  switch (value) {
    case MedicalEventTreatmentMethod.CatheterAblation:
      return 'var(--mantine-color-chartPlotLines-9)';
    case MedicalEventTreatmentMethod.Cardioversion:
      return 'var(--mantine-color-chartPlotLines-7)';
    case MedicalEventTreatmentMethod.Medication:
      return 'var(--mantine-color-chartPlotLines-5)';
    case MedicalEventType.DiagnosticResult:
      return 'var(--mantine-color-chartPlotLines-3)';
    default:
      return 'transparent';
  }
};

export const showBlankingPeriodLabel = (value?: number) => {
  if (!value) return '-';
  return `${value} ${t('weeks_label')}`;
};
